import gql from 'graphql-tag';

const WearableBodySummaryQuery = gql`
  query WearableBodySummary {
    wearable {
      bodySummary {
        provider
        device
        weightKg
        heightCm
        bodyFatPercent
        muscleMassKg
        bmi
        age
        restingHeartRateBpm
        avgHrvSdnnMs
        avgPeriodDays
        bodyTemperatureCelsius
        skinTemperatureCelsius
      }
    }
  }
`;

export default WearableBodySummaryQuery;
